<template>
  <div
    class="v-progress-wrap"
    @touchstart.stop="startHandler"
    @touchmove.stop="moveHandler"
    @touchend.stop="endHandler"
    @mousedown.stop="startHandler"
  >
    <div class="v-progress-cont">
      <div
        class="v-progress-left"
        :style="{ width: leftWidth }"
      >
        <div class="v-progress-ball" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VProgress',
  model: {
    prop: 'percent',
    event: 'change'
  },
  props: {
    percent: {
      type: [Number, String],
      default: 100
    },
    draggable: {
      type: Boolean,
      default: true
    },
    width: {
      type: Number,
      default: 0
    },
    // 是否返回整数
    isInterger: {
      type: Boolean,
      default: false
    },
    // 整数模式下返回的最小值
    min: {
      type: Number,
      default: 0
    },
    // 整数模式下返回的最大值
    max: {
      type: Number,
      default: 100
    }
  },
  data: function () {
    return {
      isDownOnBall: false, // 标记是否按下
      isCurrentProgress: false, // 主要用于防止一个页面内有多个本组件，Move时互相影响而设置的字段
      progressElement: null
    }
  },
  computed: {
    leftWidth() {
      const { width, percent } = this
      return width ? `${width}px` : `${percent}%`
    }
  },
  mounted() {
    this.progressElement = this.$el.getElementsByClassName('v-progress-cont')[0]
  },
  methods: {
    emitChange(percent) {
      let value = percent
      if (this.isInterger) {
        value = Math.round(percent)
        const { min, max } = this
        if (value < min) {
          value = min
        } else if (value > max) {
          value = max
        }
      }
      return this.$emit('change', value)
    },
    startHandler(e) {
      if (!this.draggable) return false
      this.isDownOnBall = true
      this.isCurrentProgress = true
      if (e.type === 'mousedown') {
        document.addEventListener('mousemove', this.moveHandler)
        document.addEventListener('mouseup', this.endHandler)
      }
      this.$emit('start')
    },
    moveHandler(e) {
      if (!this.draggable) return false
      if (this.isDownOnBall && this.isCurrentProgress) {
        let dx
        if (e.type === 'mousemove') {
          const { pageX, clientX } = e
          const x = pageX || clientX
          const { left } = this.$el.getBoundingClientRect()
          dx = x - left
        } else {
          const x = e.touches[0].pageX || e.touches[0].clientX
          dx = x - this.$el.offsetLeft
        }
        dx = dx >= this.$el.clientWidth ? this.$el.clientWidth : dx
        dx = dx < 0 ? 0 : dx
        const percent = (dx / this.progressElement.clientWidth) * 100
        this.emitChange(percent)
      }
    },
    endHandler(e) {
      if (!this.draggable) return false
      if (this.isDownOnBall && this.isCurrentProgress) {
        let dx
        if (e.type === 'mouseup') {
          const { left } = this.$el.getBoundingClientRect()
          dx = e.pageX - left
        } else {
          dx = e.changedTouches[0].pageX - this.$el.offsetLeft
        }
        dx = dx >= this.$el.clientWidth ? this.$el.clientWidth : dx
        dx = dx < 0 ? 0 : dx
        const percent = (dx / this.progressElement.clientWidth) * 100
        this.emitChange(percent)
        this.isDownOnBall = false
        this.isCurrentProgress = false
      }
    }
  }
}
</script>

<style lang="less">
.v-progress-wrap {
  padding: 5px 0;
  user-select: none;
}

.v-progress-cont {
  height: 4px;
  border-radius: 2px;
  background-color: #666;
}

.v-progress-left {
  position: relative;
  height: 100%;
  border-radius: 2px;
  background: @primary;
}

.v-progress-ball {
  position: absolute;
  top: 50%;
  right: -15px;
  width: 30px;
  height: 30px;
  box-sizing: border-box;
  padding: 5px;
  transform: translateY(-50%);

  &::before {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #ffca27;
    content: '';
  }
}
</style>
